import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.7.297c-.3-.293-.7-.39-1.1-.196l-19 8.8c-.4.194-.6.585-.6.976s.3.782.8.88l7.4 1.858 1.9 7.234c.1.39.5.684.9.782h.1q.6 0 .9-.587L21 1.47q.15-.733-.3-1.173m-9.4 16.326L10 11.54c-.1-.39-.4-.586-.7-.684L4 9.486l13.9-6.452z"
    }, null, -1)
  ]))]))
}
export default { render: render }